import { useLocation, useNavigate } from "react-router-dom";

import emergencyDoneIcon from "../../../../assets/img/emergency/emergency-done-icon.png";
import ResultFormat from "..";

type Props = {};
export default function EvacuationResult(props: Props) {
  const { state } = useLocation();
  const navigate = useNavigate();

  return (
    <ResultFormat
      title={"대피 완료했어요."}
      description={`${state?.situation?.evacuationCategory} 상황이 종료될 때까지\n지정된 대피장소에서\n관리자의 통제에 따라주세요.`}
      icon={emergencyDoneIcon}
      onCancel={() => navigate(state?.referer)}
      onMoveToManager={() =>
        navigate(
          `/manager/evacuation-manager/${state?.situation?.evacuationId}`,
          { replace: true }
        )
      }
      isManager={state?.isManager}
    />
  );
}
